import axios from '@axios'

const PREFIX = '/assinatura-documento'

export default {

  getLinkAutenticacao() {
    return axios.get(`${PREFIX}/link-autenticacao`)
  },

  enviarAssinatura(documentoId, payload) {
    return axios.post(`${PREFIX}/documento/confirmar-assinatura/${documentoId}`, payload)
  },

  getArquivoContrato(id, externo = false) {
    if (externo) {
      return axios.get(`${PREFIX}/portal-propostas/contrato-arquivo/${id}?externo=${externo}`)
    }
    return axios.get(`${PREFIX}/contrato-arquivo/${id}?externo=${externo}`)
  },
  deletarArquivo(fileName, externo = false) {
    if (externo) {
      return axios.delete(`${PREFIX}/portal-propostas/arquivo?filename=${fileName}`)
    }
    return axios.delete(`${PREFIX}/arquivo?filename=${fileName}`)
  },
  getDadosAssinante(documentoId, token, tenantId) {
    return axios.get(`${PREFIX}/dados-para-assinatura/${documentoId}?token=${token}`, {
      headers: { 'X-Tenant-Id': tenantId },
    })
  },
  getDadosDocumentoByChavePublica(chavePublica) {
    return axios.get(`${PREFIX}/dados-para-consulta-publica/${chavePublica}`)
  },
  AtualizarAssinantesContrato(documentoId, assinantes) {
    return axios.put(`${PREFIX}/atualizar-assinantes/${documentoId}`, assinantes)
  },
}
